import { Box } from '@chakra-ui/react';
import { FC } from 'react';
import { PanelResizeHandle } from 'react-resizable-panels';

interface ResizeHandleProps {
  direction: 'horizontal' | 'vertical';
}

/**
 * Styled resize handle for react-resizable-panels that matches Chakra UI design system.
 */
export const ResizeHandle: FC<ResizeHandleProps> = ({ direction }) => {
  const isHorizontal = direction === 'horizontal';

  return (
    <PanelResizeHandle>
      <Box
        width={isHorizontal ? '4px' : '100%'}
        height={isHorizontal ? '100%' : '4px'}
        bg="border.default"
        cursor={isHorizontal ? 'col-resize' : 'row-resize'}
        transition="background 0.2s"
        _hover={{
          bg: 'accent.default',
        }}
        _active={{
          bg: 'accent.emphasis',
        }}
        position="relative"
        zIndex={1}
      />
    </PanelResizeHandle>
  );
};
